module.exports = __webpack_public_path__ + "img/xiaoyu.812752c3.png";